import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">
              最受欢迎的漫画深度解析与最新资讯
            </p>
          </div>
          <Link
            to="/category/plot"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 bg-primary-500 text-background-50 text-xs rounded-md font-medium">
                    {article.tags[0]}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/plot"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}